export const getActiveProject = (location) => {
    let id = process.env.REACT_APP_PROJECT_KEY;
    const queryString = location.search.slice(1);
    if (queryString) {
        id = queryString;
    }
    return id
}